module.exports = __webpack_public_path__ + "static/media/contact3.0c33bbf7.png";